// Mocks for /api/secure/me/preferences. Persists per-profile to
// localStorage so dev-mode round-trips feel real.

import { delay } from './index'

const STORAGE_KEY = 'patientPortal.mock.preferences.v1'

function readStore() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
  } catch (e) {
    return {}
  }
}

function writeStore(s) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(s))
  } catch (e) {
    /* ignore */
  }
}

function emptyResponse(profile) {
  return {
    patientProfileId: profile?.id || null,
    dietaryPreference: null,
    foodTagsToExclude: null,
  }
}

export async function getPreferences(profile) {
  await delay(80)
  if (!profile) return emptyResponse(null)
  const store = readStore()
  return store[profile.id] || emptyResponse(profile)
}

const VALID_DIETS = new Set([
  'VEGETARIAN',
  'NON_VEGETARIAN',
  'VEGAN',
  'EGGETARIAN',
  'JAIN',
  'PESCATARIAN',
])

export async function updatePreferences(profile, patch) {
  await delay(120)
  if (!profile) return emptyResponse(null)
  const store = readStore()
  const current = store[profile.id] || emptyResponse(profile)
  const next = { ...current }
  if (patch?.dietaryPreference !== undefined) {
    const d = (patch.dietaryPreference || '').toString().trim()
    if (d === '') {
      next.dietaryPreference = null
    } else {
      const normalized = d.toUpperCase()
      if (!VALID_DIETS.has(normalized)) {
        const error = new Error(`Unknown dietaryPreference: ${d}`)
        error.status = 400
        throw error
      }
      next.dietaryPreference = normalized
    }
  }
  if (patch?.foodTagsToExclude !== undefined) {
    next.foodTagsToExclude = Array.isArray(patch.foodTagsToExclude)
      ? (patch.foodTagsToExclude.length > 0 ? patch.foodTagsToExclude : null)
      : null
  }
  store[profile.id] = next
  writeStore(store)
  return next
}

export function __resetPreferencesMock() {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    /* ignore */
  }
}
